/**
 * @fileoverview GET handler for the "/engagement/link_templates/select" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { engagementLinkTemplatesSelect } from "./constants";
import type { EngagementLinkTemplatesResult } from "./types";

export const getEngagementLinkTemplates = reactQueryFetcherAdapter(
  engagementLinkTemplatesSelect,
  (signal: AbortSignal): Promise<EngagementLinkTemplatesResult> => {
    return fetch("/engagement/link_templates/select", "GET", {}, { signal });
  }
);
